import type { FunctionComponent } from "react";
import type { IProps } from "./stepped-drawer-footer.types";
import { Drawer } from "../../drawer";

/**
 * Consumer-owned footer for the base SteppedDrawer. Renders in the drawer footer with right-aligned actions.
 */
const SteppedDrawerFooter: FunctionComponent<IProps> = ({ children }) => {
    return (
        <Drawer.Footer>
            <Drawer.Footer.Actions>{children}</Drawer.Footer.Actions>
        </Drawer.Footer>
    );
};

export { SteppedDrawerFooter };
